import { FC } from 'react';
import './GrowthMap.scss';
import SectionLayout from 'atoms/components/SectionLayout';
import PowerBiGraph from '../PowerBiGraph';
import { useTranslation } from 'react-i18next';

const GrowthMap: FC = () => {
  const { t } = useTranslation();

  return (
    <SectionLayout
      className="growth-map"
      header={<span className="title">{t('Growing trend')}</span>}
    >
      <PowerBiGraph pageName="d90c068d4ee90272172b" />
    </SectionLayout>
  );
};

export default GrowthMap;
